import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ManipulationsToolbarComponent } from "../../shared/components/manipulations-toolbar/manipulations-toolbar.component";
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DistributionGroupStore } from './store/distribution-group-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { DistributionGroupListComponent } from "./components/distribution-group-list/distribution-group-list.component";
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { PageTypeEnum } from 'src/app/shared/models/filter.model';

@Component({
    selector: 'que-distribution-group',
    providers: [DistributionGroupStore, ManipulationsToolbarStore],
    templateUrl: './distribution-group.component.html',
    styleUrls: ['./distribution-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ManipulationsToolbarComponent, TranslateDirective, TranslatePipe, DistributionGroupListComponent]
})
export class DistributionGroupComponent implements OnInit {
  #distributionGroupStore = inject(DistributionGroupStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  distributionGroups$ = toSignal(this.#distributionGroupStore.distributionGroup$)
  ngOnInit(): void {
    this.#manipulationsToolbarStore.updatePageType(PageTypeEnum.DistributionGroups);
  }
}
